import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DeleteDialogComponent } from 'src/app/tarriff/dialog/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-delete-whitelist',
  templateUrl: './delete-whitelist.component.html',
  styleUrls: ['./delete-whitelist.component.scss']
})
export class DeleteWhitelistComponent implements OnInit {

  yesFlag: boolean;
  apiUrl: any;
  urlDelete: string;
msisdn: string;
  constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private backendApiService: BackendApiService,
    private endPointService: EndpointsService) { }

  ngOnInit(): void {
    // this.apiUrl=this.endPointService.URL_DELETE_WHITELIST + '&sno=' + this.data.rowData.sno;
        this.yesFlag = true;
        this.urlDelete = this.data.urlDelete;
        this.msisdn = this.data.item.msisdn;
  }

  clickNo() {
    this.dialogRef.close();
  }

  clickYes() {
    this.backendApiService.callToApi(this.urlDelete).
    subscribe(response => {
      
      alert("Deleted Whitelist Successfully");
      this.dialogRef.close();
      this.storeAnalytics();
    });
  }
  storeAnalytics() {

    const apiUrl1 = this.endPointService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Whitelist' + '&module=whitelist' + '&operation=remove_msisdn'  + '&opname=msisdn' + '&opvalue='+this.msisdn;;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });


  }
}
